import styled from "styled-components";
import { media } from "../../utils";

export const Link = styled.a`
  color: ${({ theme }) => theme.color.brandPrimary.light};
`;

export const ContentBody = styled.div`
  display: flex;
  align-items: center;
`;

export const ImgMobile = styled.img`
  width: 100px;
  margin-right: 20px;
  ${media.md()} {
    display: none;
  }
`;

export const TextDescription = styled.span({
  [media.lg()]: {
    fontWeight: "500",
    fontSize: "32px",
    strong: {
      fontWeight: "inherit",
      fontSize: "inherit",
    },
  },
});
